/** Page /mariage-juif-ville-davray — landing GEO/SEO discrète.
 *  Cuisine NON certifiée casher : la page l'indique honnêtement en FAQ. */

export const MARIAGE_JUIF_CONTENT = {
  fr: {
    meta: {
      title: "Mariage juif à Ville-d'Avray (92)",
      description:
        "Réception de mariage juive dans un hôtel particulier privatisé à Ville-d'Avray (92) : menus sans porc ni fruits de mer, vin casher accepté, de 12 à 100 invités assis.",
      keywords:
        "mariage juif Ville d'Avray, salle mariage juif 92, réception juive Hauts-de-Seine, mariage sans porc Boulogne, salle mariage Versailles, vin casher",
    },
    breadcrumb: [
      { label: "Accueil", to: "/" },
      { label: "Événements", to: "/evenements" },
      { label: "Mariage", to: "/mariage" },
      { label: "Mariage juif" },
    ],
    overline: "Mariage juif · Hauts-de-Seine (92)",
    h1: "Mariage juif à Ville-d'Avray, dans un hôtel particulier privatisé",
    intro:
      "Un hôtel particulier du XIXe siècle, une terrasse de 240 m² surplombant un parc arboré, et une cuisine qui compose avec vous des menus sans porc ni fruits de mer : L'Entracte privatise tout ou partie de la maison pour votre réception de mariage, de 12 à 100 invités assis, à 15 minutes de Paris, Boulogne-Billancourt et Versailles.",
    ctaDevis: "Demander un devis",
    ctaCall: "Appeler le 01 82 00 18 67",
    heroAlt: "Table de mariage dressée à L'Entracte, hôtel particulier à Ville-d'Avray",

    brief: {
      title: "Votre réception en bref",
      caption: "Informations clés pour une réception de mariage juive à L'Entracte",
      rows: [
        ["Lieu", "Hôtel particulier privatisé, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Menus", "Sans porc ni fruits de mer, composés avec le chef"],
        ["Cuisine casher", "Notre cuisine n'est pas certifiée casher et n'a pas de supervision rabbinique"],
        ["Vin casher", "Le vin casher que vous apportez est accepté et servi par notre équipe"],
        ["Vin d'honneur", "Formule classique ou sans alcool, au choix"],
        ["Capacité", "De 12 à 100 invités assis, jusqu'à 130 en cocktail"],
        ["Espaces", "Grand Salon, Petit Salon et terrasse de 240 m² sur parc"],
        ["Durée", "3 heures incluses, prolongeable jusqu'à minuit (400 € par heure)"],
        ["Accès", "15 minutes de Paris, Boulogne-Billancourt et Versailles · stationnement à proximité immédiate"],
      ],
    },

    engagements: {
      title: "Ce que nous vous proposons",
      items: [
        {
          label: "Des menus sans porc ni fruits de mer.",
          body: " Le chef construit votre menu de réception à partir de poissons, volailles, viandes et légumes frais, sans porc ni fruits de mer.",
        },
        {
          label: "Le vin casher que vous apportez.",
          body: " Vous nous confiez vos bouteilles, nous les mettons au frais et notre équipe assure le service.",
        },
        {
          label: "Un vin d'honneur au choix.",
          body: " Champagne, ou formule sans alcool avec cocktails sans alcool et jus premium, sur la terrasse aux beaux jours.",
        },
        {
          label: "Une maison entièrement à vous.",
          body: " À partir de 50 invités, la privatisation totale vous réserve les deux salons et la terrasse.",
        },
        {
          label: "Une transparence totale.",
          body: " Notre cuisine n'est pas certifiée casher : nous vous le disons d'emblée, pour que vous puissiez décider en connaissance de cause.",
        },
        {
          label: "Une organisation sur mesure.",
          body: " Horaires, agencement des salons, espace à l'écart, arrivée des invités : dites-nous vos besoins dans la demande de devis.",
        },
      ],
    },

    menu: {
      title: "Des menus composés avec le chef",
      intro:
        "Notre cuisine, traditionnelle et créative, est entièrement faite maison à partir de produits frais. Quelques propositions, toutes sans porc ni fruits de mer :",
      groups: [
        {
          label: "Entrées",
          body:
            "saumon gravlax mariné 24 h au sel de Guérande et au poivre de Sichuan ; œuf nuage, crème forestière aux morilles ; ballottine de légumes, sauce gingembre-miel (végétarien) ; velouté de saison et ses croûtons maison.",
        },
        {
          label: "Plats",
          body:
            "filet de bar juste snacké, tian de légumes de saison ; duo de saumon et cabillaud, sauce beurre blanc ; volaille fermière rôtie, gratin de légumes et sauce champignons ; risotto crémeux aux champignons et légumes de saison.",
        },
        {
          label: "Desserts",
          body:
            "Saint-Honoré « comme une pièce montée » ; pavlova à l'orange ; tarte Tatin du chef ; salade de fruits frais ; cœur fondant au chocolat.",
        },
      ],
      note:
        "Menus végétariens, végétaliens et sans gluten possibles. Menu enfant (plat et dessert) à 40 €.",
      ctaMenu: "Voir la carte du restaurant",
      alt: "Plat préparé par le chef de L'Entracte pour une réception",
    },

    capacityTable: {
      title: "Quel espace pour combien d'invités ?",
      caption: "Espace privatisé selon le nombre d'invités adultes",
      head: ["Nombre d'invités adultes", "Espace privatisé"],
      rows: [
        ["De 12 à 29", "Le Petit Salon"],
        ["De 30 à 49", "Le Grand Salon"],
        ["50 et plus (avec cocktail apéritif)", "L'établissement entier"],
      ],
    },

    process: {
      title: "Comment organiser votre réception",
      steps: [
        "Vous nous indiquez votre date, votre nombre d'invités et vos exigences alimentaires. Nous répondons généralement sous 24 heures.",
        "Nous visitons le lieu ensemble et composons votre menu avec le chef.",
        "Vous validez le devis avec un acompte de 50 % ; la date est bloquée.",
        "Dix jours avant, vous confirmez le nombre de convives, les menus et votre heure d'arrivée.",
        "Le jour J, notre équipe coordonne le service du vin d'honneur au dernier café.",
      ],
    },

    zone: {
      title: "Une salle de réception dans l'Ouest parisien",
      intro:
        "L'Entracte est au 3 rue de Versailles, 92410 Ville-d'Avray, entre Saint-Cloud et Versailles :",
      items: [
        "Boulogne-Billancourt, Issy-les-Moulineaux et Sèvres : 10 à 15 minutes.",
        "Saint-Cloud, Garches, Vaucresson et Marnes-la-Coquette : moins de 10 minutes.",
        "Versailles, Chaville et Viroflay : 15 minutes.",
        "Paris (Porte de Saint-Cloud, 15e, 16e) : 15 à 20 minutes en voiture.",
        "En train : gare de Sèvres – Ville-d'Avray à 1 km, lignes L (Paris Saint-Lazare, La Défense) et U (La Défense).",
        "Stationnement à proximité immédiate du restaurant, accès aux personnes à mobilité réduite.",
      ],
    },

    faqTitle: "Questions fréquentes",
    faq: [
      {
        question: "Votre cuisine est-elle casher ?",
        answer:
          "Non. Notre cuisine n'est pas certifiée casher et ne dispose pas de supervision rabbinique. Nous proposons des menus sans porc ni fruits de mer, préparés dans nos cuisines, et nous acceptons le vin casher que vous apportez.",
      },
      {
        question: "Peut-on faire venir un traiteur casher extérieur ?",
        answer:
          "Non : la restauration est toujours assurée par notre cuisine, et nous ne proposons pas la location de salle seule.",
      },
      {
        question: "Les menus contiennent-ils du porc ou des fruits de mer ?",
        answer:
          "Votre menu de réception est composé sans porc ni fruits de mer. La carte du restaurant, elle, reste une carte traditionnelle française.",
      },
      {
        question: "Peut-on apporter notre vin casher ?",
        answer:
          "Oui. Vous nous confiez vos bouteilles avant la réception, nous les mettons au frais et notre équipe assure le service. À préciser dans le devis.",
      },
      {
        question: "Combien d'invités peut-on recevoir ?",
        answer:
          "De 12 à 100 invités assis, et jusqu'à 130 en cocktail en privatisation totale. Le Grand Salon reçoit de 30 à 65 invités assis et la terrasse jusqu'à 90.",
      },
      {
        question: "Quel budget prévoir ?",
        answer:
          "Nos réceptions de mariage démarrent à partir de 99 € TTC par invité, repas, boissons incluses au menu, service et privatisation de l'espace compris. Le menu enfant est à 40 €.",
      },
      {
        question: "Peut-on prévoir une organisation particulière ?",
        answer:
          "Oui : horaires adaptés, agencement des salons, espace à l'écart, arrivée des invités. Indiquez vos besoins dans votre demande de devis et nous adaptons la mise en place.",
      },
      {
        question: "Jusqu'à quelle heure peut durer la réception ?",
        answer:
          "La prestation comprend 3 heures (déjeuner 12h30-15h30 ou dîner 19h30-22h30), prolongeable jusqu'à minuit à 400 € par heure supplémentaire.",
      },
      {
        question: "Où se situe la salle par rapport à Boulogne et Versailles ?",
        answer:
          "L'Entracte est à Ville-d'Avray (92), à 10-15 minutes de Boulogne-Billancourt et de Sèvres, à 15 minutes de Versailles et de Paris, avec un stationnement à proximité immédiate.",
      },
    ],

    devis: {
      title: "Parlons de votre réception",
      body:
        "Indiquez-nous votre date, le nombre d'invités et vos exigences alimentaires : nous revenons vers vous sous 24 heures avec une proposition détaillée.",
      contact: "Téléphone : 01 82 00 18 67 · E-mail : restaurantlentractevda@gmail.com",
    },

    related: {
      title: "Aller plus loin",
      links: [
        { to: "/mariage", label: "Toutes nos formules mariage" },
        { to: "/evenements", label: "Réceptions privées & privatisation" },
        { to: "/galerie", label: "La galerie photos" },
      ],
    },

    eventType: "Mariage",
  },

  en: {
    meta: {
      title: "Jewish wedding venue in Ville-d'Avray (92)",
      description:
        "Jewish wedding reception in a private townhouse in Ville-d'Avray (92): menus without pork or shellfish, kosher wine welcome, 12 to 100 seated guests.",
      keywords:
        "Jewish wedding Ville d'Avray, wedding venue 92, Jewish reception Hauts-de-Seine, pork-free wedding Boulogne, wedding venue Versailles, kosher wine",
    },
    breadcrumb: [
      { label: "Home", to: "/" },
      { label: "Events", to: "/evenements" },
      { label: "Wedding", to: "/mariage" },
      { label: "Jewish wedding" },
    ],
    overline: "Jewish wedding · Hauts-de-Seine (92)",
    h1: "Jewish weddings in Ville-d'Avray, in a private townhouse",
    intro:
      "A 19th-century private townhouse, a 240 m² terrace overlooking a wooded park, and a kitchen that creates menus without pork or shellfish with you: L'Entracte hires out all or part of the house for your wedding reception, for 12 to 100 seated guests, 15 minutes from Paris, Boulogne-Billancourt and Versailles.",
    ctaDevis: "Request a quote",
    ctaCall: "Call +33 1 82 00 18 67",
    heroAlt: "Wedding table set at L'Entracte, a private townhouse in Ville-d'Avray",

    brief: {
      title: "Your reception at a glance",
      caption: "Key information for a Jewish wedding reception at L'Entracte",
      rows: [
        ["Venue", "Private townhouse, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Menus", "Without pork or shellfish, created with the chef"],
        ["Kosher kitchen", "Our kitchen is not kosher-certified and has no rabbinical supervision"],
        ["Kosher wine", "The kosher wine you bring is welcome and served by our team"],
        ["Reception drinks", "Classic or alcohol-free, as you prefer"],
        ["Capacity", "12 to 100 seated guests, up to 130 for a cocktail reception"],
        ["Spaces", "Grand Salon, Petit Salon and a 240 m² terrace over the park"],
        ["Duration", "3 hours included, extendable until midnight (€400 per hour)"],
        ["Getting here", "15 minutes from Paris, Boulogne-Billancourt and Versailles · parking nearby"],
      ],
    },

    engagements: {
      title: "What we offer",
      items: [
        { label: "Menus without pork or shellfish.", body: " The chef builds your reception menu from fresh fish, poultry, meat and vegetables, with no pork or shellfish." },
        { label: "The kosher wine you bring.", body: " You hand us your bottles, we chill them and our team serves them." },
        { label: "Reception drinks your way.", body: " Champagne, or an alcohol-free option with mocktails and premium juices, on the terrace in fine weather." },
        { label: "A house entirely yours.", body: " From 50 guests, full hire reserves both lounges and the terrace for you." },
        { label: "Complete transparency.", body: " Our kitchen is not kosher-certified: we say so upfront so you can decide with full knowledge." },
        { label: "Tailored arrangements.", body: " Timings, room layout, a quiet area, guest arrival: tell us your needs in the quote request." },
      ],
    },

    menu: {
      title: "Menus created with the chef",
      intro:
        "Our traditional and creative cuisine is made entirely in-house from fresh produce. A few suggestions, all without pork or shellfish:",
      groups: [
        { label: "Starters", body: "gravlax salmon marinated for 24 hours; cloud egg with woodland morel cream; vegetable ballotine with ginger and honey (vegetarian); seasonal velvet soup with house croutons." },
        { label: "Main courses", body: "seared sea bass fillet with seasonal vegetable tian; duo of salmon and cod, beurre blanc sauce; roast farm poultry, vegetable gratin and mushroom sauce; creamy mushroom and seasonal vegetable risotto." },
        { label: "Desserts", body: "Saint-Honoré served \"like a wedding cake\"; orange pavlova; the chef's tarte Tatin; fresh fruit salad; molten chocolate cake." },
      ],
      note: "Vegetarian, plant-based and gluten-free menus available. Children's menu (main course and dessert) at €40.",
      ctaMenu: "See the restaurant menu",
      alt: "Dish prepared by the chef of L'Entracte for a reception",
    },

    capacityTable: {
      title: "Which space for how many guests?",
      caption: "Private space according to the number of adult guests",
      head: ["Number of adult guests", "Space hired"],
      rows: [
        ["12 to 29", "The Petit Salon"],
        ["30 to 49", "The Grand Salon"],
        ["50 and more (with welcome cocktail)", "The entire venue"],
      ],
    },

    process: {
      title: "How to plan your reception",
      steps: [
        "You tell us your date, your number of guests and your dietary requirements. We usually reply within 24 hours.",
        "We visit the venue together and create your menu with the chef.",
        "You approve the quote with a 50% deposit; the date is secured.",
        "Ten days before, you confirm the number of guests, the menus and your arrival time.",
        "On the day, our team coordinates the service from the welcome drinks to the last coffee.",
      ],
    },

    zone: {
      title: "A reception venue in western Paris",
      intro: "L'Entracte is at 3 rue de Versailles, 92410 Ville-d'Avray, between Saint-Cloud and Versailles:",
      items: [
        "Boulogne-Billancourt, Issy-les-Moulineaux and Sèvres: 10 to 15 minutes.",
        "Saint-Cloud, Garches, Vaucresson and Marnes-la-Coquette: under 10 minutes.",
        "Versailles, Chaville and Viroflay: 15 minutes.",
        "Paris (Porte de Saint-Cloud, 15th, 16th): 15 to 20 minutes by car.",
        "By train: Sèvres – Ville-d'Avray station 1 km away, lines L and U.",
        "Parking in the immediate vicinity, access for guests with reduced mobility.",
      ],
    },

    faqTitle: "Frequently asked questions",
    faq: [
      { question: "Is your kitchen kosher?", answer: "No. Our kitchen is not kosher-certified and has no rabbinical supervision. We offer menus without pork or shellfish, prepared in our kitchen, and we welcome the kosher wine you bring." },
      { question: "Can we bring an outside kosher caterer?", answer: "No: catering is always provided by our own kitchen, and we do not offer room-only hire." },
      { question: "Do the menus contain pork or shellfish?", answer: "Your reception menu is created without pork or shellfish. The à la carte restaurant menu remains a traditional French menu." },
      { question: "Can we bring our kosher wine?", answer: "Yes. You hand us your bottles before the reception, we chill them and our team serves them. To be set out in the quote." },
      { question: "How many guests can you host?", answer: "From 12 to 100 seated guests, and up to 130 for a cocktail reception with full venue hire." },
      { question: "What budget should we plan for?", answer: "Our wedding receptions start from €99 incl. VAT per guest, including the meal, the drinks in the menu, service and private hire of the space. The children's menu is €40." },
      { question: "Can you accommodate special arrangements?", answer: "Yes: adapted timings, room layout, a quiet area, guest arrival. Mention your needs in your quote request." },
      { question: "How late can the reception run?", answer: "The package includes 3 hours (lunch 12.30-3.30pm or dinner 7.30-10.30pm), extendable until midnight at €400 per additional hour." },
      { question: "Where is the venue compared with Boulogne and Versailles?", answer: "L'Entracte is in Ville-d'Avray (92), 10-15 minutes from Boulogne-Billancourt and Sèvres, 15 minutes from Versailles and Paris, with parking nearby." },
    ],

    devis: {
      title: "Let's talk about your reception",
      body:
        "Tell us your date, the number of guests and your dietary requirements: we get back to you within 24 hours with a detailed proposal.",
      contact: "Phone: +33 1 82 00 18 67 · Email: restaurantlentractevda@gmail.com",
    },

    related: {
      title: "Go further",
      links: [
        { to: "/mariage", label: "All our wedding packages" },
        { to: "/evenements", label: "Private receptions & venue hire" },
        { to: "/galerie", label: "Photo gallery" },
      ],
    },

    eventType: "Wedding",
  },
};
